import styled from 'styled-components';
import { Divider, DatePicker } from 'antd';
import { Modal, Progress } from 'antd';

export const ContentWrapper = styled.div`
  padding: 16px 0px;
`;

export const StyldDivider = styled(Divider)`
  background-color: #d0d7e3;
`;

export const StyledImg = styled.img`
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
`;

export const Title = styled.div`
  font-size: 14px;
  color: #748aa1;
  padding-bottom: 4px;
  line-height: 17px;
  font-weight: 400;
`;

export const Description = styled.div`
  font-size: 13.2px;
  color: #b8bec5;
  padding-bottom: 2px;
  line-height: 16px;
  font-weight: 400;
`;

export const DateTitle = styled.div`
  font-size: 12px;
  color: #31394d;
  padding-bottom: 0px;
  line-height: 21.67px;
  font-weight: 600;
`;

export const DateDescription = styled.div`
  font-size: 11px;
  font-weight: 400;
  color: #748aa1;
  padding-bottom: 8px;
  line-height: 21.67px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 24px;
  gap: 8px;
`;

export const CustomDatePickerContainer = styled.div`
  position: relative;
  width: 188.5px;
  height: 28px;
`;

export const CustomDatePickerLabel = styled.label`
  position: absolute;
  top: 56%;
  left: 12px;
  transform: translateY(-50%);
  z-index: 1;
  font-size: 12px;
  font-weight: 400;
  line-height: 21.67px;
  color: #b8bec5;
`;

export const CustomDatePickerInput = styled(DatePicker)`
  padding-left: 75px;
  font-size: 12px;
  font-weight: 400;
  line-height: 21.67px;
  color: #31394d;
  border-radius: 4px;
`;

export const CustomModal = styled(Modal)`
  .ant-modal-content {
    width: 435px;
    height: 440px;
    border-radius: 15px;
    color: #ffffff;
    box-shadow: 0px 4px 15px 0px #00000026;
  }

  .ant-modal-body {
    padding: 24px 32px;
  }

  .custom-modal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px;
  }

  .custom-image {
    width: 273px;
    height: 238.56px;
    margin-bottom: 16px;
    align-self: flex-start;
  }

  .ant-modal-footer {
    border: none;
    margin-top: 32px;
    margin-right: 20px;
  }
`;

export const StyledProgress = styled(Progress)`
  width: 345px;
  height: 7px;
  margin-top: 8px;

  .ant-progress-bg {
    border-radius: 50px;
    background-color: #2b73e0;
  }
  .ant-progress-text {
    font-size: 11px;
    line-height: 21.67px;
    color: #748aa1;
    font-weight: 400;
  }
`;
